import classNames from 'classnames';
import React from 'react';
import GlassLabel from './GlassLabel';
import Label from './Label';
import { numberOfLables } from './lib';

const CONFIGS = {
  1: ['singleDoor'],
  2: ['sideLite', 'singleDoor'],
  3: ['singleDoor', 'sideLite'],
  4: ['sideLite', 'singleDoor', 'sideLite'],
  5: ['doubleDoor'],
  6: ['sideLite', 'doubleDoor'],
  7: ['doubleDoor', 'sideLite'],
  8: ['sideLite', 'doubleDoor', 'sideLite'],
};

export default ({ estimate }) =>
  estimate.systems
    .filter(({ type }) => type !== 'misc')
    .sort((a, b) => a.mark.localeCompare(b.mark))
    .map((system, index) => {
      if (['fd', 'sf'].includes(system.type)) {
        return [...system.verticals]
          .sort((a, b) => a.index - b.index)
          .map((vertical, verticalIndex) => {
          const classes = classNames('mx-auto border', {
            'mt-5': index === 0 && verticalIndex === 0,
          });
          const config = CONFIGS[system.config] || [];
          const isFdSideLite =
            system.type === 'fd' && config[verticalIndex] === 'sideLite';
          const isFdDoubleDoor =
            system.type === 'fd' && config[verticalIndex] === 'doubleDoor';

          return (
            <React.Fragment key={`${system.id}-${verticalIndex}`}>
              <Label
                estimate={estimate}
                system={system}
                index={verticalIndex}
                classes={classes}
                width={vertical.width}
                systemModifier={isFdSideLite && 'Side Lite'}
              />
              {isFdDoubleDoor && (
                <Label
                  estimate={estimate}
                  system={system}
                  index={verticalIndex}
                  classes="mx-auto border"
                  width={vertical.width}
                />
              )}
            </React.Fragment>
          );
          });
      }

      const labels = numberOfLables(system);
      const classes = classNames('mx-auto border', { 'mt-5': index === 0 });

      return Array.from(
        { length: labels },
        (_, labelIndex) =>
          system.type !== 'glass' ? (
            <Label
              key={`${system.id}-${labelIndex}`}
              estimate={estimate}
              system={system}
              index={labelIndex}
              classes={classes}
            />
          ) : (
            <GlassLabel
              key={`${system.id}-${labelIndex}`}
              estimate={estimate}
              system={system}
              index={labelIndex}
              classes={classes}
            />
          )
      );
    });
